import { useState } from "react";
import { Moon, Sun } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";

const ThemeToggle = ({ className = "" }) => {
    const { t } = useLanguage();
    const [dark, setDark] = useState(() => document.documentElement.classList.contains("dark"));

    const toggle = (e) => {
        const next = !dark;
        const applyTheme = () => {
            document.documentElement.classList.toggle("dark", next);
            try {
                localStorage.setItem("tp-theme", next ? "dark" : "light");
            } catch {
                /* private mode */
            }
            setDark(next);
        };
        const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        if (reduce || typeof document.startViewTransition !== "function") {
            applyTheme();
            return;
        }
        const x = e?.clientX ?? window.innerWidth - 80;
        const y = e?.clientY ?? 60;
        document.documentElement.style.setProperty("--vt-x", `${x}px`);
        document.documentElement.style.setProperty("--vt-y", `${y}px`);
        document.startViewTransition(applyTheme);
    };

    return (
        <button
            type="button"
            onClick={toggle}
            aria-label={dark ? t.theme.toLight : t.theme.toDark}
            aria-pressed={dark}
            data-testid="theme-toggle"
            className={`flex min-h-11 min-w-11 items-center justify-center rounded-full border border-ink/15 bg-surface/70 text-pine transition-colors duration-300 hover:border-gold-500 hover:text-gold-600 ${className}`}
        >
            {dark ? <Sun className="h-5 w-5" strokeWidth={1.75} aria-hidden="true" /> : <Moon className="h-5 w-5" strokeWidth={1.75} aria-hidden="true" />}
        </button>
    );
};

export default ThemeToggle;
